
// const root = process.env.VUE_APP_API

// const ext = process.env.VUE_APP_API_EXT

// const DEV = {
//     cities:         root + "/cities" + ext,
//     travels:        root + "/travels" + ext,
//     prices:         root + "/prices" + ext,
//     save:           root + "/save" + ext,
//     reservation:    root + "/reservation" + ext,
//     updPrices:      root + "/public/update-prices" + ext,
//     update:         root + "/public/update" + ext,
//     updateConfirm:  root + "/public/update-confirmation" + ext
// }

const PROD = {
    cities:        'https://www.sgtm.com/api/cities.php',             // ok
    travels:       'https://www.sgtm.com/api/travels.php',            // ok
    prices:        'https://www.sgtm.com/api/prices.php',             // ok
    save:          'https://www.sgtm.com/api/save.php',  
    save_test:     'https://www.sgtm.com/api/save_test.php',              // ok
    saveConfirm:   'https://www.sgtm.com/api/save-confirmation.php',  // ok
    reservation:   'https://www.sgtm.com/api/reservation.php',        // ok
    updPrices:     'https://www.sgtm.com/api/update-prices.php',      // ok
    update:        'https://www.sgtm.com/api/update.php',             // ok
    updateConfirm: 'https://www.sgtm.com/api/update-confirmation.php',// WARNING, NEW USE FOR THIS SCRIPT (previously used to validate a new reservation, and now used to validate an update)


}

// const PROD = {
//     cities:        'https://www.sgtm.com/apitest/cities.php',             // ok
//     travels:       'https://www.sgtm.com/apitest/travels.php',            // ok
//     prices:        'https://www.sgtm.com/apitest/prices.php',             // ok
//     save:          'https://www.sgtm.com/apitest/save.php',  
//     save_test:     'https://www.sgtm.com/apitest/save.php',              // ok
//     saveConfirm:   'https://www.sgtm.com/apitest/save-confirmation.php',  // ok
//     reservation:   'https://www.sgtm.com/apitest/reservation.php',        // ok
//     updPrices:     'https://www.sgtm.com/apitest/update-prices.php',      // ok
//     update:        'https://www.sgtm.com/apitest/update.php',             // ok
//     updateConfirm: 'https://www.sgtm.com/apitest/update-confirmation.php',// WARNING, NEW USE FOR THIS SCRIPT (previously used to validate a new reservation, and now used to validate an update)


// }

/*
    On force l'API PROD, même en dev, parce qu'on a besoin d'être en mode DEV
    pour exploiter l'extension Google Chrome VueJS, mais on veux tester l'API de MCI32
*/
const API = PROD
// const API = process.env.NODE_ENV.startsWith('dev') ? DEV : PROD

// console.log(process.env.NODE_ENV)
// console.log(DEV)
// console.log(API)


export default API


